"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardOperasyonelSchema = exports.TAKVIM_KAYNAK_ETIKETI = exports.dashboardTakvimSatiriSchema = exports.yaklasanVadeKonuOzetiSchema = exports.yaklasanVadeSatiriSchema = exports.yaklasanVadeKonusuSchema = exports.YAKLASAN_VADE_KONU_ETIKETI = exports.dashboardKiyasSchema = exports.dashboardKiyasSatiriSchema = exports.kpiKiyasHucresiSchema = exports.DASHBOARD_KIYAS_KIRILIM_ETIKETI = exports.dashboardKiyasKirilimiSchema = exports.DASHBOARD_KIYAS_KIRILIMLARI = exports.dashboardKpiSchema = exports.dashboardSecenekleriSchema = exports.dashboardKapsamSecenegiSchema = exports.dashboardKapsamTipiSchema = exports.DASHBOARD_KAPSAM_TIPLERI = exports.kpiUcSayiSchema = exports.kpiOraniSchema = exports.TEHLIKE_BILDIRIMI_SAYILAN_UYGUNSUZLUK_DURUMLARI = exports.TEHLIKE_BILDIRIMI_SAYILAN_OLAY_DURUMLARI = exports.DASHBOARD_DONEM_ETIKETI = exports.DASHBOARD_DONEM_VARSAYILAN = exports.dashboardDonemiSchema = exports.DASHBOARD_DONEMLERI = exports.KPI_KOLONLARI = exports.KPI_CARPAN_ETIKETI = exports.kpiCarpanSchema = exports.KPI_CARPAN_VARSAYILAN = exports.KPI_CARPANLARI = exports.SIDDET_OLUMLU_SIRA = exports.ORAN_KPI_TIPLERI = exports.LTIF_ESIK_SIRA = exports.TRIF_ESIK_SIRA = void 0;
exports.oranKpiEsigi = oranKpiEsigi;
exports.kayipGunGirilebilirMi = kayipGunGirilebilirMi;
exports.kayipGunEksikMi = kayipGunEksikMi;
exports.kpiKolonuOf = kpiKolonuOf;
exports.oranHesapla = oranHesapla;
exports.calisanBasina = calisanBasina;
exports.dashboardDonemAraligi = dashboardDonemAraligi;
const zod_1 = require("zod");
const incident_1 = require("./incident");
const vade_1 = require("./vade");
/**
 * ═ DASHBOARD KPI KURALLARI (TUR 12 — Kapsam §26) ═══════════════════════════
 *
 * ⚠️ **DASHBOARD HİÇBİR SAYIYI KENDİ HESAPLAMAZ** — bu dosya *kuralı*
 * taşır, *sorguyu* değil. Sorgular modülün kendi dosyasındadır
 * (`@isg/db incident-kpi.ts`); ekran ikisini de yeniden yazmaz.
 */
// ── Eşikler (K2) ─────────────────────────────────────────────────────────────
/**
 * **EŞİK `sira` DEĞERİNE BAĞLIDIR, KALEM ID'SİNE DEĞİL.** Müşteri merdiven
 * kaleminin ADINI değiştirebilir (O6); KPI bundan etkilenmez. Merdivenin
 * kendisi ÜRÜN KİLİTLİDİR (`SIDDET_MERDIVENI_*`, §16.8/4) — bu iki sayı o
 * kilidin üstünde durur.
 *
 * ⚠️ ***"Kayıtlı (gün kaybı yok)" BİR BASAMAK DEĞİL, BİR KPI'DIR***
 * (`incident.ts` merdiven notu): TRIF ile LTIF'in FARKI odur. Merdivene
 * basamak ekleyerek bu ayrımı kurmaya çalışan, iki müşterinin oranını
 * kıyaslanamaz hâle getirir.
 */
/** TRIF — kaydedilebilir kaza: tıbbi müdahale ve üstü. */
exports.TRIF_ESIK_SIRA = 2;
/** LTIF — kayıp günlü kaza: kayıp günlü ve üstü. */
exports.LTIF_ESIK_SIRA = 3;
exports.ORAN_KPI_TIPLERI = ['trif', 'ltif'];
function oranKpiEsigi(tip) {
    return tip === 'trif' ? exports.TRIF_ESIK_SIRA : exports.LTIF_ESIK_SIRA;
}
// ── Kayıp gün kuralı (madde 309 — ürün sahibi 08.10.2026; Kapsam §16.8/13 ✏️) ──
/** Ölümlü basamak — merdivenin tepesi (`SIDDET_MERDIVENI_MAX_SIRA`). */
exports.SIDDET_OLUMLU_SIRA = incident_1.SIDDET_MERDIVENI_MAX_SIRA;
/**
 * **ÖLÜMLÜ BASAMAKTA KAYIP GÜN GİRİLMEZ; NULL MEŞRU DEĞERDİR** (309-a).
 * TR konvansiyonu (7.500 gün) **kayda yazılmaz** — Faz 5 KPI seti için rapor
 * kuralı olarak notlandı (§16.8.1 açık ucu). Servis bu yüklemle 422 verir,
 * ekran alanı pasifler; ikinci kopya yazılmaz.
 */
function kayipGunGirilebilirMi(siddetBasamagi) {
    return siddetBasamagi !== exports.SIDDET_OLUMLU_SIRA;
}
/**
 * **KAYIP GÜNLÜ BASAMAKTA (3–4) KAYIP GÜN BOŞSA EKSİKTİR** (309-b/c): olay
 * kaydında kalıcı uyarı (R13 deseni — kapanışı engellemez) ve Kayıp gün
 * kartının alt satırı *"n vakada kayıp gün girilmemiş"* bu yüklemden sayılır.
 * ⚠️ Ölümlü vakanın NULL'ı sayıya GİRMEZ (309-a); oran KPI'ı dışı taraflar
 * (ziyaretçi · üçüncü şahıs) da girmez — kayıp gün çalışma gününe aittir.
 */
function kayipGunEksikMi(taraf, siddetBasamagi, kayipGun) {
    if (kpiKolonuOf(taraf) === null)
        return false;
    if (!kayipGunGirilebilirMi(siddetBasamagi))
        return false;
    return siddetBasamagi >= exports.LTIF_ESIK_SIRA && kayipGun == null;
}
// ── Çarpan (K1) ──────────────────────────────────────────────────────────────
/**
 * **ÇARPAN EKRANDA SÜZGEÇTİR** (Kapsam §26.1); tenant ayarı `kpi_carpan`
 * yalnız **varsayılanı** verir.
 *
 * ⚠️ **§16.8.1/2 AYNEN GEÇERLİ:** hesaplanmış oran HİÇBİR YERDE SAKLANMAZ ve
 * `work_hours_record`'a çarpan kolonu AÇILMAZ. Kararı doğuran senaryo
 * ürün sahibinindir: aynı dönem için Suudi ihalesine 200.000'lik,
 * sürdürülebilirlik raporuna 1.000.000'luk oran **EŞZAMANLI** istenir —
 * sıralı bir değişiklik değil, iki ayrı çıktı. Bu yüzden çarpan bir
 * **yapılandırma değil, RAPOR PARAMETRESİDİR**; tenant ayarına kilitlenseydi
 * ikinci çıktı için ayarın değiştirilmesi, ilk çıktının da anlamının
 * değişmesi gerekirdi.
 */
exports.KPI_CARPANLARI = [200_000, 1_000_000];
exports.KPI_CARPAN_VARSAYILAN = 1_000_000;
exports.kpiCarpanSchema = zod_1.z
    .number()
    .int()
    .refine((deger) => exports.KPI_CARPANLARI.includes(deger), {
    message: 'Çarpan yalnız 200.000 veya 1.000.000 olabilir',
});
/** Ekranda ve çıktı antetinde basılan biçim (TR ayracı). */
exports.KPI_CARPAN_ETIKETI = {
    200_000: '200.000',
    1_000_000: '1.000.000',
};
// ── Kolonlar / taraf eşlemesi (K3) ───────────────────────────────────────────
/**
 * ÜÇ SAYI (K3). ⚠️ Ayrım **hem payda hem paydada AYNI eksende** yapılır:
 * pay `incident_affected_person.taraf`, payda `work_hours_record.contractor_id`.
 * Biri ayrıştırılıp diğeri ayrıştırılmasaydı yüklenici oranı ana firmanın
 * saatine bölünür ve **sessizce küçülürdü.**
 */
exports.KPI_KOLONLARI = ['ana_isveren', 'yuklenici', 'toplam'];
/**
 * Etkilenen kişinin oran kolonu — `null` = **ORANA HİÇ GİRMEZ**
 * (`ORAN_KPI_DISI_TARAFLAR`, R10: ziyaretçi ve üçüncü şahsın çalışma saati
 * yoktur; dışlanmazsa oran sessizce şişer). ⚠️ Bu kişiler olay SAYISINA ve
 * şiddet dağılımına GİRER — dışlama yalnız **oran KPI'ının payındadır**.
 */
function kpiKolonuOf(taraf) {
    if (incident_1.ORAN_KPI_DISI_TARAFLAR.includes(taraf))
        return null;
    return taraf === 'contractor_worker' ? 'yuklenici' : 'ana_isveren';
}
// ── Oran hesabı (K12) ────────────────────────────────────────────────────────
/**
 * **BOŞ ≠ SIFIR.** Payda yoksa (çalışma saati hiç girilmemiş) oran `null`
 * döner ve ekran BOŞLUK gösterir.
 *
 * ⚠️ Sıfır bir ÖLÇÜMDÜR (*"bu dönemde kaza olmadı"*), boş bir
 * BİLGİSİZLİKTİR (*"paydayı bilmiyoruz"*). İkisini aynı hücreye yazan
 * gösterge, veri girilmediği için **mükemmel görünen** bir işyeri üretir —
 * §2.40'ın en sessiz kolu.
 */
function oranHesapla(pay, paydaSaat, carpan) {
    if (paydaSaat <= 0)
        return null;
    return (pay * carpan) / paydaSaat;
}
/** "Çalışan başına" metriklerin ortak yüklemi — payda ÇALIŞAN SAYISIDIR. */
function calisanBasina(pay, calisanSayisi) {
    if (calisanSayisi <= 0)
        return null;
    return pay / calisanSayisi;
}
// ── Dönem (K7'nin ikinci ekseni) ─────────────────────────────────────────────
exports.DASHBOARD_DONEMLERI = ['ytd', 'son_3_ay', 'son_6_ay', 'son_12_ay'];
exports.dashboardDonemiSchema = zod_1.z.enum(exports.DASHBOARD_DONEMLERI);
exports.DASHBOARD_DONEM_VARSAYILAN = 'ytd';
exports.DASHBOARD_DONEM_ETIKETI = {
    ytd: 'Yıl başından bugüne',
    son_3_ay: 'Son 3 ay',
    son_6_ay: 'Son 6 ay',
    son_12_ay: 'Son 12 ay',
};
/**
 * Dönem → [başlangıç, bitiş) aralığı — **UTC gün sınırlarında**.
 *
 * ⚠️ **BAŞLANGIÇ AYIN İLK GÜNÜNE ÇEKİLİR** ve bu bilinçlidir: payda
 * (`work_hours_record.donem`) AY granülünde tutulur, pay (olay tarihi) GÜN
 * granülünde. Başlangıç ayın ortasına düşseydi o ayın **tam saati** paydaya
 * girerken **yarım ayın** olayları paya girer ve oran sessizce küçülürdü.
 *
 * ⚠️ Bitiş **YARIN**dır (yarı açık aralık) — bugünün kayıtları düşmesin.
 *
 * ✏️ **MADDE 302 (01.10.2026): "BUGÜN" SAHA GÜNÜDÜR** (`yerelGun`). Önce
 * sunucunun UTC gününden okunuyordu: Türkiye'de 00:00–03:00 arasında dönem
 * DÜNE göre kuruluyordu — yılbaşı gecesi YTD bir önceki yılı, ayın ilk gecesi
 * son N ay bir ay geriyi gösteriyordu. Sınırların kendisi aynen (saha
 * gününün UTC gece yarısı — `@db.Date` kolonlarının karşılaştırma değeri).
 */
function dashboardDonemAraligi(donem, bugun = new Date()) {
    const [yil, ayNo, gun] = (0, vade_1.yerelGun)(bugun).split('-').map(Number);
    const ay = ayNo - 1;
    const bitis = new Date(Date.UTC(yil, ay, gun + 1));
    if (donem === 'ytd')
        return { baslangic: new Date(Date.UTC(yil, 0, 1)), bitis };
    const geriAy = donem === 'son_3_ay' ? 2 : donem === 'son_6_ay' ? 5 : 11;
    return { baslangic: new Date(Date.UTC(yil, ay - geriAy, 1)), bitis };
}
// ── Sayılan kayıt (K5'in ortak koşulu) ───────────────────────────────────────
/**
 * **TEHLİKE BİLDİRİMİ SAYIMINA GİREN DURUMLAR.**
 *
 * ⚠️ İki durum dışarıdadır ve ikisinin gerekçesi FARKLIDIR:
 *   · `rejected` — asılsız ya da mükerrer (R7/U5); bir bildirim değil, bir
 *     düzeltmedir.
 *   · `moved`   — kayıt DİĞER KAPTA yaşamaya devam eder (U7 çapraz bağı);
 *     iki yerde birden sayılsaydı taşınan her bildirim **ikiye katlanırdı**.
 *
 * ⚠️ **POZİTİF LİSTE YAZILIR, `!== 'rejected'` DEĞİL** (0b dersi): yeni bir
 * durum token'ı eklendiğinde negatif koşul sessizce yanlışa döner, pozitif
 * liste **derleme hatası** verir.
 */
exports.TEHLIKE_BILDIRIMI_SAYILAN_OLAY_DURUMLARI = ['reported', 'investigating'];
exports.TEHLIKE_BILDIRIMI_SAYILAN_UYGUNSUZLUK_DURUMLARI = ['reported'];
// ── API sözleşmesi (K7 — etiket ZORUNLU) ────────────────────────────────────
/**
 * Bir oran hücresi. ⚠️ **PAY VE PAYDA DA DÖNER** — yalnız `oran` dönseydi
 * kullanıcı boşluğun sebebini (payda yok mu, kaza yok mu) göremez ve
 * göstergeye güvenemezdi.
 */
exports.kpiOraniSchema = zod_1.z.object({
    /** Kaydedilebilir/kayıp günlü VAKA sayısı (etkilenen KİŞİ, kayıt değil). */
    pay: zod_1.z.number().int(),
    paydaSaat: zod_1.z.number(),
    /** `null` = payda yok → BOŞ gösterilir, sıfır DEĞİL (K12). */
    oran: zod_1.z.number().nullable(),
});
exports.kpiUcSayiSchema = zod_1.z.object({
    anaIsveren: exports.kpiOraniSchema,
    yuklenici: exports.kpiOraniSchema,
    toplam: exports.kpiOraniSchema,
});
exports.DASHBOARD_KAPSAM_TIPLERI = ['tumu', 'sirket', 'isyeri'];
exports.dashboardKapsamTipiSchema = zod_1.z.enum(exports.DASHBOARD_KAPSAM_TIPLERI);
exports.dashboardKapsamSecenegiSchema = zod_1.z.object({
    tip: exports.dashboardKapsamTipiSchema,
    /** `tumu` seçeneğinde null. */
    id: zod_1.z.uuid().nullable(),
    etiket: zod_1.z.string(),
});
/**
 * Ekranın açılış verisi. ⚠️ **KAPSAM SEÇENEKLERİ SUNUCUDAN GELİR** — istemci
 * bahçeyi yeniden türetmez (§2.16/B3): bahçesi boş bir kullanıcı yalnız
 * *"Tümü"*yü görür ve o da boş bir küme çözer.
 */
exports.dashboardSecenekleriSchema = zod_1.z.object({
    kapsamlar: zod_1.z.array(exports.dashboardKapsamSecenegiSchema),
    varsayilanCarpan: exports.kpiCarpanSchema,
});
/**
 * ⚠️ **ETİKET SAYININ YANINDA GELİR VE ZORUNLUDUR** (K7): aynı ekran iki
 * kişide iki farklı LTIF gösterir ve **İKİSİ DE DOĞRUDUR** — biri holdingin,
 * diğeri tek şantiyenin oranıdır. Etiketsiz bir sayı, hangi sahayı ölçtüğünü
 * söylemediği için **yanlış okunmaya açıktır**; bu yüzden `kapsamEtiketi`
 * yanıtın kendisinde durur, ekranda kurulmaz (çıktı da aynısını basar, K10).
 */
exports.dashboardKpiSchema = zod_1.z.object({
    kapsamEtiketi: zod_1.z.string(),
    donem: exports.dashboardDonemiSchema,
    donemEtiketi: zod_1.z.string(),
    carpan: exports.kpiCarpanSchema,
    carpanEtiketi: zod_1.z.string(),
    /** Kapsamdaki işyeri sayısı — boş bahçenin görünür karşılığı. */
    isyeriSayisi: zod_1.z.number().int(),
    calisanSayisi: zod_1.z.number().int(),
    trif: exports.kpiUcSayiSchema,
    ltif: exports.kpiUcSayiSchema,
    kayipGun: zod_1.z.object({
        anaIsveren: zod_1.z.number().int(),
        yuklenici: zod_1.z.number().int(),
        toplam: zod_1.z.number().int(),
        /** Madde 309-c: kayıp günlü basamakta (3–4) `kayip_gun` boş vaka sayısı —
         *  ölümlü vakanın NULL'ı GİRMEZ (`kayipGunEksikMi` tek yüklemi). */
        eksikVaka: zod_1.z.number().int(),
    }),
    kazaSayisi: zod_1.z.number().int(),
    /**
     * ⚠️ **ADI "TEHLİKE BİLDİRİMİ"DİR** (K5): pay = ramak kala (olay kabı) +
     * tehlikeli durum/davranış (uygunsuzluk kabı). **KAZA SAYILMAZ** — o
     * LTIF/TRIF'in payıdır. Kaynak kırılımı görünür kalır (madde 153).
     */
    tehlikeBildirimi: zod_1.z.object({
        olay: zod_1.z.number().int(),
        uygunsuzluk: zod_1.z.number().int(),
        toplam: zod_1.z.number().int(),
        calisanBasina: zod_1.z.number().nullable(),
    }),
    /** ⚠️ Birim DERS SAATİDİR, saat değil (K16 / madde 173). */
    egitim: zod_1.z.object({
        dersSaati: zod_1.z.number(),
        calisanBasina: zod_1.z.number().nullable(),
    }),
});
/**
 * KIYAS GÖRÜNÜMÜ (gezinti artçısı 07.09.2026 — G1.1; tur 12'nin "v2" kararı
 * ürün sahibince GERİ AÇILDI). Seçili kapsamın **ALT KIRILIMI** kıyaslanır:
 * holding seçiliyse şirketler, şirket seçiliyse işyerleri, işyeri seçiliyse
 * tek satır (kıyas yok — üst kapsam önerilir). Süzgeç ile kıyasın ilişkisi
 * budur: kıyas ikinci bir kapsam seçici AÇMAZ, süzgeci bir kademe aşağı okur.
 *
 * ⚠️ Her satır AYNI yüklemle (`olayKpiOzeti` + `calismaSaatiOzeti`) üretilir —
 * üst KPI bloğuyla ikinci bir hesap yolu doğmaz. `cubuk` sunum payıdır
 * (satırın oranı / kırılımdaki en büyük oran; oran boşsa null) ve SUNUCUDA
 * hesaplanır — ekran hiçbir sayıyı kendi hesaplamaz (§26/K6).
 */
exports.DASHBOARD_KIYAS_KIRILIMLARI = ['sirket', 'isyeri'];
exports.dashboardKiyasKirilimiSchema = zod_1.z.enum(exports.DASHBOARD_KIYAS_KIRILIMLARI);
exports.DASHBOARD_KIYAS_KIRILIM_ETIKETI = {
    sirket: 'Şirketler',
    isyeri: 'İşyerleri',
};
exports.kpiKiyasHucresiSchema = exports.kpiOraniSchema.extend({
    /** 0..1 — kırılımdaki en büyük orana göre pay; oran boşsa null. */
    cubuk: zod_1.z.number().min(0).max(1).nullable(),
});
exports.dashboardKiyasSatiriSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    etiket: zod_1.z.string(),
    isyeriSayisi: zod_1.z.number().int(),
    /** Toplam kesim (ana işveren + yüklenici) — kıyas tek kesimle okunur. */
    trif: exports.kpiKiyasHucresiSchema,
    ltif: exports.kpiKiyasHucresiSchema,
    kazaSayisi: zod_1.z.number().int(),
});
exports.dashboardKiyasSchema = zod_1.z.object({
    kapsamEtiketi: zod_1.z.string(),
    kirilim: exports.dashboardKiyasKirilimiSchema,
    kirilimEtiketi: zod_1.z.string(),
    donemEtiketi: zod_1.z.string(),
    carpanEtiketi: zod_1.z.string(),
    satirlar: zod_1.z.array(exports.dashboardKiyasSatiriSchema),
});
// ── (B) OPERASYONEL BLOK (K8 · K9 — Kapsam §26.6) ───────────────────────────
exports.YAKLASAN_VADE_KONU_ETIKETI = {
    egitim_yetkinlik_vadesi: 'Eğitim geçerlilikleri',
    saglik_kanaat_vadesi: 'Sağlık muayeneleri',
    ekipman_kontrol: 'Ekipman periyodik kontrolleri',
    evrak_gecerlilik: 'Yüklenici evrakları',
};
exports.yaklasanVadeKonusuSchema = zod_1.z.enum([
    'egitim_yetkinlik_vadesi',
    'saglik_kanaat_vadesi',
    'ekipman_kontrol',
    'evrak_gecerlilik',
]);
exports.yaklasanVadeSatiriSchema = zod_1.z.object({
    konu: exports.yaklasanVadeKonusuSchema,
    kaynakRef: zod_1.z.uuid().nullable(),
    baslik: zod_1.z.string(),
    bitis: zod_1.z.iso.date(),
    gecti: zod_1.z.boolean(),
    /** ⚠️ `null` = tekil ekranı yok → satır DÜZ METİN (ölü bağ çizilmez). */
    bagli: zod_1.z.object({ tip: zod_1.z.enum(['ekipman', 'kanaat', 'yuklenici']), id: zod_1.z.uuid() }).nullable(),
});
exports.yaklasanVadeKonuOzetiSchema = zod_1.z.object({
    konu: exports.yaklasanVadeKonusuSchema,
    etiket: zod_1.z.string(),
    toplam: zod_1.z.number().int(),
    gecmis: zod_1.z.number().int(),
    satirlar: zod_1.z.array(exports.yaklasanVadeSatiriSchema),
});
/**
 * TAKVİM (K9). ⚠️ Her satır **KAYNAĞINI TAŞIR** — `yukumluluk_kalemi` mi
 * `ekipman_tipi` mi. *"Üçüncü takvim kavramı açılmaz"* kuralının görünür
 * yüzü budur: aynı listede iki kaynak yan yana durur ve karışmaz.
 *
 * ⚠️ **YALNIZ İLERİYE BAKAR:** geçmiş vadeler *"süresi geçenler"* bloğunun
 * (T8) işidir. İkisi aynı sayfada aynı soruya farklı sayılarla cevap
 * vermesin diye sınır KODA yazılmıştır (`gorevTakvimi`).
 */
exports.dashboardTakvimSatiriSchema = zod_1.z.object({
    occurrenceId: zod_1.z.uuid(),
    kalemAd: zod_1.z.string(),
    kaynak: zod_1.z.enum(['ekipman_tipi', 'yukumluluk_kalemi']),
    nesneAd: zod_1.z.string(),
    workplaceAd: zod_1.z.string(),
    vadeTarihi: zod_1.z.iso.date(),
});
exports.TAKVIM_KAYNAK_ETIKETI = {
    ekipman_tipi: 'Ekipman',
    yukumluluk_kalemi: 'Yasal yükümlülük',
};
exports.dashboardOperasyonelSchema = zod_1.z.object({
    /** ⚠️ Kapsam BAHÇEDİR — (A) bloğunun kapsam süzgeci burada KOŞMAZ (§26.6). */
    kapsamEtiketi: zod_1.z.string(),
    vadeler: zod_1.z.array(exports.yaklasanVadeKonuOzetiSchema),
    takvim: zod_1.z.array(exports.dashboardTakvimSatiriSchema),
});
//# sourceMappingURL=kpi.js.map